<section class="boarding-sec">
  <div class="container">
    <div class="inner-banner d-flex align-items-center bg-primary my-5">
      <h1>{{ planDetails?.name | titlecase }}</h1>
      <img [src]="filePath + planDetails?.id +'/cover_image/' + planDetails?.cover_image" alt="" class="bg-img" />
    </div>
    <div class="row">
      <div class="col-12">
        <div class="wizard mb-5">
          <ul ngbNav #nav="ngbNav" [(activeId)]="active" (navChange)="changeTab($event)"
            class="nav-tabs nav nav-tabs justify-content-center border-0 w-100 flex-nowrap">
            <li [ngbNavItem]="'tab1'" class="flex-fill" id="tab1">
              <button ngbNavLink class="w-100">
                <div class="d-flex align-items-center">
                  <img [src]="'assets/images/wellness-plan/select-plan.svg'" alt="" class="me-3 d-none d-lg-block" />
                  <h6 class="m-0 text-start me-2 d-none d-md-block">Select Plan</h6>
                </div>

                <div class="count">
                  @if(isRightMarkForFirst){
                  <img [src]="'assets/images/wellness-plan/completed.svg'" alt="" />
                  } @else {
                  <span>01</span>
                  }
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-md-none">Select Plan</h4>
                <div class="tab-pane mt-md-5">
                  <div class="text-center title-box">
                    <h3 class="text-primary">Pricing You Will Love</h3>
                    <p>{{ planDetails?.short_description }}</p>
                  </div>
                  <div class="row my-4 justify-content-center">
                    <!-- price box -->
                    @for (plan of plans; track $index) {

                    <div class="col-lg-4 col-md-6 mb-4">
                      <div class="camp-box" [ngClass]="{
                          planSelected: plan.id == selectedPlanId
                        }">
                        @if (plan.is_popular == '1') {
                        <span class="ribbon">Popular</span>
                        }
                        <div class="camp-head" [ngClass]="{'hasDiscounted': !plan.discounted}">
                          <!-- <span class="text-uppercase">Bronze</span> -->
                          <h6 class="camp-desc mb-3 text-primary d-flex align-items-center">
                            <span [ngbTooltip]="plan.title" class="d-block title">
                              {{ plan.title }}
                            </span>
                            <span (click)="
                                showDescription(plan?.title, plan?.description)
                              " ngbTooltip="View Description of {{
                                plan.title | titlecase
                              }}"
                              class="bg-success d-inline-flex align-items-center justify-content-center rounded-circle custom-question-mark cursor-pointer">
                              <i class="fa fa-question text-white"></i>
                            </span>
                          </h6>
                          <div class="camp-price">
                            <div>
                              <span class="currency-sign h3 fw-bold text-info">${{ plan.doller }}.{{ plan.cent }}
                              </span>/MO
                            </div>
                            @if (plan.discounted>0) {
                            <div class="d-flex align-items-center fw-bold mt-3">
                              <span class="offer-price text-decoration-line-through"
                                [ngClass]="{ invisible: !plan.isDiscount }">{{ plan.actual_price | currency }}/MO</span>
                              <span class="badge ms-3">{{ plan.discounted }}% OFF!</span>
                            </div>
                            }
                          </div>
                        </div>
                        <div class="camp-mid">
                          <div class="text-info my-3">What’s Included</div>
                          <ul class="camp-listpoint">
                            @for (service of plan.sortServices; track $index) {
                            <li [ngClass]="{'d-none d-md-flex':service.title == ''}">
                              <ng-template #popContent>
                                <div class="d-flex">
                                  <p>{{ service.description }}</p>
                                </div>
                              </ng-template>

                              @if(service.title != ''){
                              <div class="d-flex align-items-center">
                                <div class="icon-box me-2 green">
                                  <i class="fa-solid fa-check"></i>
                                </div>
                                <div>
                                  <span container="body" placement="auto" [ngbPopover]="popContent"
                                    popoverTitle="{{ service?.title }}" class="custom-popover cursor">
                                    {{ service.title }}

                                    @if(service?.pivot.value != '0'){
                                    <span class="color-change">({{ service?.pivot.value }} time)</span>
                                    }
                                  </span>
                                </div>
                              </div>
                              } @else {
                              <div class="d-flex align-items-center">
                                <div class="icon-box me-2 red">
                                  <i class="fa-solid fa-xmark"></i>
                                </div>
                                <span>------</span>
                              </div>
                              }
                            </li>
                            }
                          </ul>
                        </div>
                        <div class="camp-bottom" [ngbTooltip]="
                            !plan?.is_available_for_outpost
                              ? 'This wellness plan is not available at your selected Center.'
                              : ''
                          ">
                          @if (plan.id != selectedPlanId) {
                          <a [disabled]="!plan?.is_available_for_outpost" [ngClass]="{
                                disabled: !plan?.is_available_for_outpost
                              }" (click)="
                                plan?.is_available_for_outpost
                                  ? selectPlan(plan)
                                  : ''
                              " class="btn w-100 btn-outline-success">
                            <span> Select</span>
                          </a>
                          }

                          @if (plan.id == selectedPlanId) {

                          <a class="btn w-100 btn-success">
                            <span>Selected</span>
                          </a>
                          }
                        </div>
                      </div>
                    </div>

                    }
                  </div>
                  <div
                    class="d-flex justify-content-center justify-content-md-between bottom-strip align-items-center flex-column flex-md-row">
                    <div class="d-flex flex-row flex-md-column align-items-center mb-3 mb-md-0">
                      <span>Total Monthly Price:</span>
                      <h3 class="text-info m-0"> {{ totalPrice | currency }}</h3>
                    </div>
                    <a class="btn btn-success next" (click)="
                        planDetails?.is_available_for_outpost ? goToNext() : ''
                      " [disabled]="!planDetails?.is_available_for_outpost" [ngClass]="{
                        disabled: !planDetails?.is_available_for_outpost
                      }">Continue the next step</a>
                  </div>
                  <div class="mt-4">
                    @if(!planDetails?.is_available_for_outpost){
                    <div class="bottom-link">
                      This wellness plan is not available at your selected
                      Center.
                      <a href="javascript:void(0)" (click)="onSelect()">
                        <u class="fw-bold">Click Here</u>
                      </a>
                      to change Center.
                    </div>
                    }
                  </div>
                </div>
              </ng-template>
            </li>
            @if (extraServices?.length) {
            <li [ngbNavItem]="'tab2'" class="flex-fill" [disabled]="!selectedPlanId"
              [ngClass]="{ disabled: !selectedPlanId }" id="tab2">
              <button ngbNavLink class="w-100">
                <div class="d-flex align-items-center">
                  <img [src]="'assets/images/wellness-plan/select-service.svg'" alt="" class="me-3 d-none d-lg-block" />
                  <h6 class="m-0 text-start me-2 d-none d-md-block">Select Extra services</h6>
                </div>

                <div class="count">
                  @if(isRightMarkForSecond){
                  <img [src]="'assets/images/wellness-plan/completed.svg'" alt="" />
                  } @else {
                  <span>02</span>
                  }
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-md-none">Select Extra services</h4>
                <div class="tab-pane mt-md-5">
                  <div class="text-center title-box">
                    <h3>Extra-services that Add Stars to your Plan</h3>
                    <p>
                      Extra-service show how much you care. Select from our
                      wide-range of additional services.
                    </p>
                  </div>
                  <div class="row my-4 camp-listing">
                    @for (service of extraServices; track $index) {
                    <div class="col-sm-6 col-lg-4 mb-4">
                      <div class="camp-plan-box cursor-pointer d-flex justify-content-between flex-nowrap" [ngClass]="{
                            'plancard-selected': selectedServices.includes(
                              service.id
                            )
                          }" (click)="!extraServicesInPlan?.includes(service.id) ? selectServices(service): '' "
                        [ngbTooltip]="extraServicesInPlan?.includes(service.id)? 'This Extra Service is already in your selected plan level.' : '' ">
                        <div class="me-4">
                          <div class="plan-title text-primary">
                            {{ service.title }}
                          </div>
                          <div class="plan-price">
                            <span>{{ service?.monthly_price | currency }}</span>
                            /MO
                          </div>
                          <div class="plan-decs">
                            {{
                            service.short_description.length > 45
                            ? (service?.short_description
                            | slice : 0 : 99) + "..."
                            : service?.short_description
                            }}
                            @if (service.short_description.length > 45) {
                            <a href="javascript:void(0)" (click)="
                                  $event.stopPropagation();
                                  showDescription(
                                    service?.title,
                                    service.short_description
                                  )
                                " class="text-info link">Read More</a>
                            }
                          </div>
                        </div>
                        <div class="select-checkbox">
                          <input type="checkbox" id="check_{{ i }}" class="form-check-input"
                            [checked]="selectedServices.includes(service.id)" (change)="selectServices(service)"
                            [disabled]="
                                !service?.is_available_for_outpost ||
                                extraServicesInPlan?.includes(service.id)
                              " />
                          <label for="check_{{ i }}"> </label>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                  <div
                    class="d-flex justify-content-center justify-content-md-between bottom-strip align-items-center flex-column flex-md-row">
                    <div class="d-flex flex-row flex-md-column align-items-center mb-3 mb-md-0">
                      <span>Total Monthly Price:</span>
                      <h3 class="text-info m-0"> {{ totalPrice | currency }}</h3>
                    </div>
                    <div class="text-center text-md-end">
                      <a class="btn btn-outline-success prev me-md-4 mb-4 mb-md-0" (click)="goToPrev()">Back</a>
                      <a class="btn btn-success next" (click)="goToNext()">Continue the next step</a>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>
            }
            <li [ngbNavItem]="extraServices?.length?'tab3':'tab2'" class="flex-fill" [disabled]="!selectedPlanId"
              [ngClass]="{ disabled: !selectedPlanId }" [id]="extraServices?.length?'tab3':'tab2'">
              <button ngbNavLink class="w-100">
                <div class="d-flex align-items-center">
                  <img [src]="'assets/images/wellness-plan/add-details.svg'" alt="" class="me-3 d-none d-lg-block" />
                  <h6 class="m-0 text-start me-2 d-none d-md-block">Add Pet Details</h6>
                </div>
                <div class="count">
                  <span>
                    @if (extraServices?.length) {
                    03
                    }@else {
                    02
                    }
                  </span>
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-md-none">Add Pet Details</h4>
                <div class="tab-pane mt-md-5">
                  <div class="pet-form-box my-4" [formGroup]="petDetails">
                    @if(isAuthenticatedUser){
                    <div class="tob-box px-lg-5 px-4 py-lg-0 py-4">
                      <div class="row justify-content-between align-items-center">
                        <div class="col-lg-8">
                          <h3>Pet Details</h3>
                          <p>
                            Please enter your pet's details for our medical
                            records.
                          </p>
                          <div class="select-pet d-flex mt-4 flex-column flex-md-row">
                            <div class="select-box d-flex flex-column">
                              <ng-select class="form-control custom-ng-dropdown-panel input-select form-input-with-box"
                                [items]="userPets" [placeholder]="'Select Your Pet'" bindLabel="name" bindValue="id"
                                [searchable]="false" dropdownPosition="bottom" formControlName="pet_id"
                                (change)="petSelectionChange($event)">
                              </ng-select>
                              <small class="d-block mt-auto">You can select one pet at the same time.</small>
                            </div>
                            <div class="ms-md-3 text-center mt-3 mt-md-0 text-md-start">
                              <button class="btn btn-success" (click)="petSelectionChange()">
                                Add New Pet
                              </button>
                              <small class="d-block mt-3">Have a New Pet? Add your new pet here.</small>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 text-end d-none d-lg-block">
                          <img [src]="'assets/images/wellness-plan/wellness-bg-dog.png'" alt="" class="mt-4" />
                        </div>
                      </div>
                    </div>
                    }
                    <div class="bottom-box">
                      <div class="row">
                        <div class="col-lg-4 text-center text-lg-start">
                          <div class="content-box position-relative h-100 p-4">
                            <h3>
                              Extra-services that <span>Add Stars</span> to your
                              Plan
                            </h3>
                            <p>
                              Extra-service show how much you care. Select from
                              our wide-range of additional services.
                            </p>
                            <img [src]="'assets/images/wellness-plan/wellness-form-dog.png'" alt=""
                              class="img-fluid shadow-img" />
                          </div>
                        </div>
                        <div class="col-lg-8">
                          <div class="form-box h-100 p-5">
                            <h3 class="text-primary">Pet Details</h3>
                            <p>
                              Please enter your pet's details for our medical
                              records.
                            </p>
                            <div class="row">
                              <div class="col-md-6 mb-4">
                                <input type="text" trim="blur" id="name" name="name" formControlName="name"
                                  class="form-control" placeholder="Your Pet’s Name" autocomplete="off"
                                  [attr.disabled]="petDetails?.value?.pet_id ? true : null"
                                  [ngClass]="{'disabled': petDetails?.value?.pet_id}" />
                                @if( (petDetails?.controls?.name?.touched ||
                                petDetails?.controls?.name?.dirty ||submitted)
                                && !petDetails?.controls?.name?.valid
                                &&!petDetails?.controls?.name?.pending){
                                @if(petDetails?.controls?.name?.errors?.required){
                                <span class="text-danger error">Pet name is required</span>
                                } }
                              </div>
                              <div class="col-md-6 mb-4">
                                <select class="form-control form-select" id="sex" name="sex" formControlName="sex"
                                  [ngModel]="select_sex[0]" [attr.disabled]="petDetails?.value?.pet_id ? true : null"
                                  [ngClass]="{'disabled': petDetails?.value?.pet_id}" placeholder="Select Sex">
                                  @for (sex_type of select_sex; track $index) {
                                  <option value="{{ sex_type }}">
                                    {{ sex_type | titlecase }}
                                  </option>
                                  }
                                </select>

                                @if((petDetails?.controls?.sex?.touched
                                ||petDetails?.controls?.sex?.dirty || submitted)
                                && !petDetails?.controls?.sex?.valid &&
                                !petDetails?.controls?.sex?.pending) {
                                @if(petDetails?.controls?.sex?.errors?.required){
                                <span class="text-danger error">Sex is required</span>
                                } }
                              </div>
                              <div class="col-md-6 mb-4">
                                <input type="text" trim="blur" id="color" name="color" formControlName="color"
                                  class="form-control" placeholder="Colour"
                                  [attr.disabled]="petDetails?.value?.pet_id ? true : null"
                                  [ngClass]="{'disabled': petDetails?.value?.pet_id}" />

                                @if((petDetails?.controls?.color?.touched ||
                                petDetails?.controls?.color?.dirty || submitted)
                                && !petDetails?.controls?.color?.valid &&
                                !petDetails?.controls?.color?.pending){
                                @if(petDetails?.controls?.color?.errors?.required){
                                <span class="text-danger error">
                                  Color is required
                                </span>
                                } }
                              </div>
                              <div class="col-md-6 mb-4">
                                <input type="text" trim="blur" id="age" name="age" formControlName="age"
                                  class="form-control" placeholder="Age (in years)"
                                  [attr.disabled]="petDetails?.value?.pet_id ? true : null"
                                  [ngClass]="{'disabled': petDetails?.value?.pet_id}" />

                                @if((petDetails?.controls?.age?.touched ||
                                petDetails?.controls?.age?.dirty || submitted)
                                && !petDetails?.controls?.age?.valid &&
                                !petDetails?.controls?.age?.pending){
                                <span class="text-danger error">
                                  @if(petDetails?.controls?.age?.errors?.required){
                                  Age is required }
                                  @if(petDetails?.controls?.age?.errors?.pattern){
                                  Age must be a valid number with up to one decimal place
                                  }
                                </span>
                                }
                              </div>
                              <div class="col-md-6 mb-4">
                                <input type="text" trim="blur" id="weight" name="weight" formControlName="weight"
                                  class="form-control" placeholder="Weight (in lbs)"
                                  [attr.disabled]="petDetails?.value?.pet_id ? true : null"
                                  [ngClass]="{'disabled': petDetails?.value?.pet_id}" />

                                @if((petDetails?.controls?.weight?.touched ||
                                petDetails?.controls?.weight?.dirty ||
                                submitted) &&
                                !petDetails?.controls?.weight?.valid &&
                                !petDetails?.controls?.weight?.pending){
                                <span class="text-danger error">
                                  @if(petDetails?.controls?.weight?.errors?.required){
                                  Weight is required }
                                  @if(petDetails?.controls?.weight?.errors?.pattern){
                                  Weight Should be valid numeric value }
                                </span>
                                }
                              </div>
                              <div class="col-md-6 mb-4">
                                <input type="text" trim="blur" id="breed" name="breed" formControlName="breed"
                                  class="form-control" placeholder="Breed"
                                  [attr.disabled]="petDetails?.value?.pet_id ? true : null"
                                  [ngClass]="{'disabled': petDetails?.value?.pet_id}" />

                                @if((petDetails?.controls?.breed?.touched ||
                                petDetails?.controls?.breed?.dirty || submitted)
                                && !petDetails?.controls?.breed?.valid &&
                                !petDetails?.controls?.breed?.pending){
                                <span class="text-danger error">
                                  @if(petDetails?.controls?.breed?.errors?.required){
                                  Breed is required }
                                </span>
                                }
                              </div>
                              <div class="col-md-6 mb-4">
                                <input type="text" trim="blur" id="microchip" name="microchip"
                                  formControlName="microchip" class="form-control" placeholder="Microchip"
                                  [attr.disabled]="petDetails?.value?.pet_id ? true : null"
                                  [ngClass]="{'disabled': petDetails?.value?.pet_id}" />
                              </div>
                              <div class="col-md-6 mb-4">
                                <input type="text" id="description" name="description" formControlName="description"
                                  class="form-control" placeholder="Identification Mark"
                                  [attr.disabled]="petDetails?.value?.pet_id ? true : null"
                                  [ngClass]="{'disabled': petDetails?.value?.pet_id}" />
                              </div>
                              <div class="col-12">
                                <div class="d-flex align-items-center justify-content-between flex-column flex-md-row">
                                  <div class="d-flex flex-row flex-md-column align-items-center mb-3 mb-md-0">
                                    <span>Total Monthly Price</span>
                                    <h3 class="text-info m-0">
                                      {{ totalPrice | currency }}
                                    </h3>
                                  </div>
                                  <button class="btn btn-success" (click)="
                                      planDetails?.is_available_for_outpost
                                        ? savePetDetails()
                                        : ''
                                    " [ngClass]="{
                                      disabled:
                                        !planDetails?.is_available_for_outpost
                                    }">
                                    {{
                                    !planEditMode
                                    ? "Add To Cart"
                                    : "Update Cart"
                                    }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between">
                    <a class="btn btn-outline-success prev" (click)="goToPrev()">Back</a>
                  </div>
                </div>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
      </div>
    </div>
  </div>
</section>